import JSBI from 'jsbi'

// exports for external consumption
export type BigintIsh = JSBI | bigint | string

export const INITIAL_ALLOWED_SLIPPAGE = 50

export enum ChainId {
  MAINNET = 1,
  SEPOLIA = 11155111,
  SN_MAIN = -1,
  SN_SEPOLIA = -11155111,
  BSC_TESTNET = 97,
  BSC_MAINNET = 56,
  VICTION_TESTNET = 89,
  VICTION_MAINNET = 88,
  SONIC_TESTNET = 64165,
  MINATO_SONEIUM = 1946,
  BASE_SEPOLIA = 84532,
  BASE_MAINNET = 8453,
  UNICHAIN_SEPOLIA = 1301,
  AURORA_TESTNET = 1313161555,
  METIS_MAINNET = 1088,
  TAIKO_TESTNET = 167009,
  BOBA_TESTNET = 28882,
  NEOX_MAINNET = 47763,
  U2U_MAINNET = 39,
  SCROLL_TESTNET = 534351,
  ARBITRUM_SEPOLIA = 421614,
  ARBITRUM_MAINNET = 42161,
  BERA_MAINNET = 80094,
  HYPER_EVM = 999,
  OP_MAINNET = 10,
  BOBA_MAINNET = 288
}

export const ChainIdHex: any = {
  [ChainId.MAINNET]: '0x1',
  [ChainId.SEPOLIA]: '0xaa36a7',
  [ChainId.BSC_TESTNET]: '0x61',
  [ChainId.BSC_MAINNET]: '0x38',
  [ChainId.VICTION_TESTNET]: '0x59',
  [ChainId.VICTION_MAINNET]: '0x58',
  [ChainId.SONIC_TESTNET]: '0xFAA5',
  [ChainId.MINATO_SONEIUM]: '0x79A',
  [ChainId.BASE_SEPOLIA]: '0x14a34',
  [ChainId.BASE_MAINNET]: '0x2105',
  [ChainId.UNICHAIN_SEPOLIA]: '0x515',
  [ChainId.AURORA_TESTNET]: '0x4e454153',
  [ChainId.METIS_MAINNET]: '0x440',
  [ChainId.TAIKO_TESTNET]: '0x28c61',
  [ChainId.BOBA_TESTNET]: '0x70d2',
  [ChainId.NEOX_MAINNET]: '0xba93',
  [ChainId.U2U_MAINNET]: '0x27',
  [ChainId.SCROLL_TESTNET]: '0x8274f',
  [ChainId.ARBITRUM_SEPOLIA]: '0x66FBE',
  [ChainId.ARBITRUM_MAINNET]: '0xa4b1',
  [ChainId.BERA_MAINNET]: '0x138de',
  [ChainId.HYPER_EVM]: '0x3e7',
  [ChainId.OP_MAINNET]: '0xa',
  [ChainId.BOBA_MAINNET]: '0x120'
}

export enum TradeType {
  EXACT_INPUT,
  EXACT_OUTPUT
}

export enum Rounding {
  ROUND_DOWN,
  ROUND_HALF_UP,
  ROUND_UP
}

export const ROUTER_ADDRESS: any = {
  [ChainId.MAINNET]: '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D',
  [ChainId.SEPOLIA]: '0x341b485D40c072B63eE2175f84f4514CF08447B9',
  [ChainId.SN_MAIN]: '',
  [ChainId.SN_SEPOLIA]:
    '0x07365f5f8f2f7748d31653133ba5a8be7501d5d90e9893e91372e44b4fe9c967',
  [ChainId.BSC_TESTNET]: '0xdbbF4542574a8c6e54e3F0e5f8F9Eea3e463F9B8',
  [ChainId.BSC_MAINNET]: '0xD3F729D909a7E84669A35c3F25b37b4AC3487784',
  [ChainId.MINATO_SONEIUM]: '0x6D1f381cF674CeE888E61b088b78202559eCEEAB',
  [ChainId.VICTION_TESTNET]: '0x44FCf63f47F7d9587b67781cB46842dcFd95A9E8',
  [ChainId.VICTION_MAINNET]: '0x7932606E387479C9cc97efde08BDcaFC5A50ac5A',
  [ChainId.SONIC_TESTNET]: '0x44FCf63f47F7d9587b67781cB46842dcFd95A9E8',
  [ChainId.BASE_SEPOLIA]: '0x7cb2CF3dde3d518b408ea0B83738C067EEdb571D',
  [ChainId.BASE_MAINNET]: '0x3240853b71c89209ea8764CDDfA3b81766553E55',
  [ChainId.UNICHAIN_SEPOLIA]: '0x7cb2CF3dde3d518b408ea0B83738C067EEdb571D',
  [ChainId.AURORA_TESTNET]: '0x7cb2CF3dde3d518b408ea0B83738C067EEdb571D',
  [ChainId.METIS_MAINNET]: '0xcfdcAC1f0bb8a212990Ec408f0d27A7EC5384ac6',
  [ChainId.TAIKO_TESTNET]: '0x7cb2CF3dde3d518b408ea0B83738C067EEdb571D',
  [ChainId.BOBA_TESTNET]: '0x782783378a9D3BCCC8d9A03F5ED452263758a571',
  [ChainId.NEOX_MAINNET]: '0xa244C6d127Ec19689f0DEf715417736c7f6cf0C4',
  [ChainId.U2U_MAINNET]: '0x40c2Be0C8c421235BDD93714BCac4ffB6A4067a5',
  [ChainId.SCROLL_TESTNET]: '0x782783378a9D3BCCC8d9A03F5ED452263758a571',
  [ChainId.ARBITRUM_SEPOLIA]: '0xbfe20401749C65a6245A8f62b682626399e115E2',
  [ChainId.ARBITRUM_MAINNET]: '0x3240853b71c89209ea8764CDDfA3b81766553E55',
  [ChainId.BERA_MAINNET]: '0x3F0bBeEdEa5E5F63a14cBdA82718d4f25501fBeA', // V2
  [ChainId.HYPER_EVM]: '0x0A461D280891167Ee8391f4F0c03EECaa39ae632',
  [ChainId.OP_MAINNET]: '0x40c2Be0C8c421235BDD93714BCac4ffB6A4067a5',
  [ChainId.BOBA_MAINNET]: '0x40c2Be0C8c421235BDD93714BCac4ffB6A4067a5'
}

export const ROUTER_ADDRESS_V1: any = {
  [ChainId.BERA_MAINNET]: '0x40c2Be0C8c421235BDD93714BCac4ffB6A4067a5',
  [ChainId.VICTION_MAINNET]: '0x7932606E387479C9cc97efde08BDcaFC5A50ac5A',
  [ChainId.U2U_MAINNET]: '0x40c2Be0C8c421235BDD93714BCac4ffB6A4067a5'
}

// For V1
export const ROUTER_ADDRESS_WITH_PRICE: any = {
  [ChainId.VICTION_MAINNET]: '0x0194CcfC49C3ebc7457E0b41B9c6b840C22f5985',
  [ChainId.SONIC_TESTNET]: '0x0f97Ca4E6B118502f83DD3Ce836A14Cb4937ed2a',
  [ChainId.AURORA_TESTNET]: '0x83A8D57634239a9e52197d34cbc74CD9455383d1',
  [ChainId.TAIKO_TESTNET]: '0x68Ce9bf4De2E0f44f39d80611d21556665120b91',
  [ChainId.BOBA_TESTNET]: '0x44FCf63f47F7d9587b67781cB46842dcFd95A9E8',
  [ChainId.BOBA_MAINNET]: '0xa244C6d127Ec19689f0DEf715417736c7f6cf0C4',
  [ChainId.BERA_MAINNET]: '0xa244C6d127Ec19689f0DEf715417736c7f6cf0C4'
}

export const FACTORY_ADDRESS: any = {
  [ChainId.MAINNET]: '0xD705B4e18055D8Fa1d099d0533163a9e8fA09E4A',
  [ChainId.SEPOLIA]: '0x43aFB543FdbcD0F00CeA9119819225F5Dc1Ec55d',
  [ChainId.SN_MAIN]: '',
  [ChainId.SN_SEPOLIA]:
    '0x05d789e22a62125d58773cd899e1b609b476b5daa0c86dccb32c72836dcec906',
  [ChainId.BSC_TESTNET]: '0xE780EEd4C1bADbdcbc702C7e6870Cab51005444A',
  [ChainId.BSC_MAINNET]: '0x43AB776770cC5c739adDf318Af712DD40918C42d',
  [ChainId.VICTION_TESTNET]: '0x782783378a9D3BCCC8d9A03F5ED452263758a571',
  [ChainId.VICTION_MAINNET]: '0xa80258Eea4BA0865610eb239045737D08929c40b',
  [ChainId.SONIC_TESTNET]: '0x7cb2CF3dde3d518b408ea0B83738C067EEdb571D',
  [ChainId.MINATO_SONEIUM]: '0x0e63FffdB5d9Db4a3595Dc9F87cB6BBc4789fF9e',
  [ChainId.BASE_SEPOLIA]: '0x86d86dD68a2D7FD82de9760D447f1Ef11644B535',
  [ChainId.BASE_MAINNET]: '0x43AB776770cC5c739adDf318Af712DD40918C42d',
  [ChainId.UNICHAIN_SEPOLIA]: '0x86d86dD68a2D7FD82de9760D447f1Ef11644B535',
  [ChainId.AURORA_TESTNET]: '0x86d86dd68a2d7fd82de9760d447f1ef11644b535',
  [ChainId.METIS_MAINNET]: '0x797691C82093Fe9EfAD6ceAcB1FC3080C2a4F85A',
  [ChainId.TAIKO_TESTNET]: '0x86d86dD68a2D7FD82de9760D447f1Ef11644B535',
  [ChainId.BOBA_TESTNET]: '0x7cb2CF3dde3d518b408ea0B83738C067EEdb571D',
  [ChainId.NEOX_MAINNET]: '0x40c2Be0C8c421235BDD93714BCac4ffB6A4067a5',
  [ChainId.U2U_MAINNET]: '0xb077EA75Bf218bf028AcEEBe61AEA4c4Ad85f62c',
  [ChainId.SCROLL_TESTNET]: '0x7cb2CF3dde3d518b408ea0B83738C067EEdb571D',
  [ChainId.ARBITRUM_SEPOLIA]: '0x8c9faEC6aED9BA0578f4C02cECb3cfE75DEf0856',
  [ChainId.ARBITRUM_MAINNET]: '0xD05395a6b6542020FBD38D31fe1377130b35592E',
  [ChainId.BERA_MAINNET]: '0x43AB776770cC5c739adDf318Af712DD40918C42d', // V2
  [ChainId.HYPER_EVM]: '0x3240853b71c89209ea8764CDDfA3b81766553E55',
  [ChainId.OP_MAINNET]: '0xb077EA75Bf218bf028AcEEBe61AEA4c4Ad85f62c',
  [ChainId.BOBA_MAINNET]: '0xb077EA75Bf218bf028AcEEBe61AEA4c4Ad85f62c'
}

export const FACTORY_ADDRESS_V1: any = {
  [ChainId.BERA_MAINNET]: '0xb077EA75Bf218bf028AcEEBe61AEA4c4Ad85f62c',
  [ChainId.VICTION_MAINNET]: '0xa80258Eea4BA0865610eb239045737D08929c40b',
  [ChainId.U2U_MAINNET]: '0xb077EA75Bf218bf028AcEEBe61AEA4c4Ad85f62c'
}

export const INIT_CODE_HASH: any = {
  [ChainId.MAINNET]:
    '0xa92e1262e78c2029fb68aa25cd33df22da5c26a36d5ca3e7f82777add081632c',
  [ChainId.SEPOLIA]:
    '0xbcc73a27bdc3b703355edcfc04a012b1f2429e8501166b39158c19d079d031d1',
  [ChainId.BSC_TESTNET]:
    '0x6b3b1d7e371199ab6de148d0ee63bc6809b9691d75ef9341bf6950bf4501702b',
  [ChainId.BSC_MAINNET]:
    '0xba3704b080a922b1d5cc299de67778312cff58ab8b1704742d9b0b19c359e228',
  [ChainId.VICTION_TESTNET]:
    '0x711312ac9a4efcfb1916d57f2ec6e03f5e1299e46f449ac9400da95ffc6d5a42',
  [ChainId.VICTION_MAINNET]:
    '0x330370b2bbf44605dd620805d2a2da4be4d6830689cdc295936cb2f1efb5e4af',
  [ChainId.SONIC_TESTNET]:
    '0x114d0544828b902794dd44ecddc6d536315d4f8ef581de0fcac30677b2b9e26b',
  [ChainId.MINATO_SONEIUM]:
    '0xf2eab90754ebe4f7948efc0065f1fec022ffaed2fff5c5048776cf8ce4701a19',
  [ChainId.BASE_SEPOLIA]:
    '0x330370b2bbf44605dd620805d2a2da4be4d6830689cdc295936cb2f1efb5e4af',
  [ChainId.BASE_MAINNET]:
    '0xba3704b080a922b1d5cc299de67778312cff58ab8b1704742d9b0b19c359e228',
  [ChainId.UNICHAIN_SEPOLIA]:
    '0x330370b2bbf44605dd620805d2a2da4be4d6830689cdc295936cb2f1efb5e4af',
  [ChainId.AURORA_TESTNET]:
    '0x330370b2bbf44605dd620805d2a2da4be4d6830689cdc295936cb2f1efb5e4af',
  [ChainId.METIS_MAINNET]:
    '0x330370b2bbf44605dd620805d2a2da4be4d6830689cdc295936cb2f1efb5e4af',
  [ChainId.TAIKO_TESTNET]:
    '0x330370b2bbf44605dd620805d2a2da4be4d6830689cdc295936cb2f1efb5e4af',
  [ChainId.BOBA_TESTNET]:
    '0x330370b2bbf44605dd620805d2a2da4be4d6830689cdc295936cb2f1efb5e4af',
  [ChainId.NEOX_MAINNET]:
    '0x330370b2bbf44605dd620805d2a2da4be4d6830689cdc295936cb2f1efb5e4af',
  [ChainId.U2U_MAINNET]:
    '0x330370b2bbf44605dd620805d2a2da4be4d6830689cdc295936cb2f1efb5e4af',
  [ChainId.SCROLL_TESTNET]:
    '0x330370b2bbf44605dd620805d2a2da4be4d6830689cdc295936cb2f1efb5e4af',
  [ChainId.ARBITRUM_SEPOLIA]:
    '0xba3704b080a922b1d5cc299de67778312cff58ab8b1704742d9b0b19c359e228',
  [ChainId.ARBITRUM_MAINNET]:
    '0xba3704b080a922b1d5cc299de67778312cff58ab8b1704742d9b0b19c359e228',
  [ChainId.BERA_MAINNET]:
    '0xba3704b080a922b1d5cc299de67778312cff58ab8b1704742d9b0b19c359e228', // V2
  [ChainId.HYPER_EVM]:
    '0xba3704b080a922b1d5cc299de67778312cff58ab8b1704742d9b0b19c359e228',
  [ChainId.OP_MAINNET]:
    '0x330370b2bbf44605dd620805d2a2da4be4d6830689cdc295936cb2f1efb5e4af',
  [ChainId.BOBA_MAINNET]:
    '0x330370b2bbf44605dd620805d2a2da4be4d6830689cdc295936cb2f1efb5e4af'
}

export const INIT_CODE_HASH_V1: any = {
  [ChainId.BERA_MAINNET]:
    '0x330370b2bbf44605dd620805d2a2da4be4d6830689cdc295936cb2f1efb5e4af',
  [ChainId.VICTION_MAINNET]:
    '0x330370b2bbf44605dd620805d2a2da4be4d6830689cdc295936cb2f1efb5e4af',
  [ChainId.U2U_MAINNET]:
    '0x330370b2bbf44605dd620805d2a2da4be4d6830689cdc295936cb2f1efb5e4af'
}

export const MINIMUM_LIQUIDITY = JSBI.BigInt(1000)

// exports for internal consumption
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const TWO = JSBI.BigInt(2)
export const THREE = JSBI.BigInt(3)
export const FIVE = JSBI.BigInt(5)
export const TEN = JSBI.BigInt(10)
export const _100 = JSBI.BigInt(100)
export const _997 = JSBI.BigInt(997)
export const _1000 = JSBI.BigInt(1000)

export enum SolidityType {
  uint8 = 'uint8',
  uint256 = 'uint256'
}

export const SOLIDITY_TYPE_MAXIMA = {
  [SolidityType.uint8]: JSBI.BigInt('0xff'),
  [SolidityType.uint256]: JSBI.BigInt(
    '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'
  )
}
